/**
 * De qué vitrina del Home salió cada venta.
 *
 * Cada sección de la portada marca su contenedor con `data-vitrina="sección/colección"`. Al hacer clic en
 * un juego se guarda, en este navegador y por 7 días, de qué vitrina vino. En la ficha de ese juego el
 * formulario de compra lleva la propiedad oculta `_vitrina`: Shopify la guarda en la línea del pedido
 * (el guion bajo la esconde en el carrito y en el checkout) y GamesOps Hub la lee al traer los pedidos.
 *
 * No usa parámetros en la URL: canonical-product-urls.js los quita a propósito.
 */
(() => {
  'use strict';

  const CLAVE = 'anubis:vitrinas';
  const VIGENCIA_MS = 7 * 24 * 60 * 60 * 1000;
  const PROPIEDAD = 'properties[_vitrina]';

  const leer = () => {
    try {
      const datos = JSON.parse(window.localStorage.getItem(CLAVE) || '{}');
      return datos && typeof datos === 'object' ? datos : {};
    } catch {
      return {};
    }
  };

  const guardar = (datos) => {
    try {
      window.localStorage.setItem(CLAVE, JSON.stringify(datos));
    } catch {
      // Sin almacenamiento (modo privado estricto) no hay atribución, pero la compra sigue igual.
    }
  };

  const vigente = (dato, ahora = Date.now()) => Boolean(dato && dato.v && ahora - Number(dato.t || 0) <= VIGENCIA_MS);

  // El handle del juego en /products/<handle> o /<idioma>/products/<handle>.
  const handleDe = (href) => {
    try {
      const url = new URL(href, window.location.origin);
      if (url.origin !== window.location.origin) return '';
      const coincide = url.pathname.match(/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?products\/([^/]+)/i);
      return coincide ? decodeURIComponent(coincide[1]).toLowerCase() : '';
    } catch {
      return '';
    }
  };

  const recordarClic = (event) => {
    const objetivo = event.target;
    if (!(objetivo instanceof Element)) return;
    const enlace = objetivo.closest('a[href]');
    const vitrina = enlace && enlace.closest('[data-vitrina]');
    if (!vitrina || !vitrina.dataset.vitrina) return;
    const handle = handleDe(enlace.getAttribute('href'));
    if (!handle) return;

    const ahora = Date.now();
    const datos = leer();
    for (const [clave, dato] of Object.entries(datos)) {
      if (!vigente(dato, ahora)) delete datos[clave];
    }
    const valor = vitrina.dataset.vitrina.slice(0, 80);
    datos[handle] = { v: valor, t: ahora };
    guardar(datos);
    if (typeof window.clarity === 'function') window.clarity('set', 'vitrina', valor);
  };

  // A cada formulario de compra del juego que llegó desde una vitrina, la propiedad oculta.
  const marcar = (raiz = document) => {
    const datos = leer();
    for (const componente of raiz.querySelectorAll('product-form-component[data-product-url]')) {
      const dato = datos[handleDe(componente.dataset.productUrl)];
      if (!vigente(dato)) continue;
      for (const form of componente.querySelectorAll('form')) {
        let campo = form.querySelector(`input[name="${PROPIEDAD}"]`);
        if (!campo) {
          campo = document.createElement('input');
          campo.type = 'hidden';
          campo.name = PROPIEDAD;
          form.appendChild(campo);
        }
        campo.value = dato.v;
      }
    }
  };

  document.addEventListener('click', recordarClic, true);
  document.addEventListener('auxclick', recordarClic, true);
  // En captura: corre antes de que product-form.js arme el envío.
  document.addEventListener(
    'submit',
    (event) => {
      const componente = event.target instanceof Element && event.target.closest('product-form-component');
      if (componente) marcar(componente.parentElement || document);
    },
    true
  );

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => marcar());
  } else {
    marcar();
  }
})();
